import {AppHelper} from "@/AppHelper";
import {computed, getCurrentInstance, ref} from "vue";
import StyleClassicPreview from "@/preview/ClassicStyle";
import StylePoetPreview from "@/preview/PoetStyle";
import StyleAstronomerPreview from "@/preview/AstronomerStyle";
import StyleAquarellesPreview from "@/preview/AquarellesStyle";
import StyleRomanticPreview from "@/preview/RomanticStyle";
import StyleModernPreview from "@/preview/ModernStyle";
import StylePhotographerPreview from "@/preview/PhotographerStyle";
import StyleExplorerPreview from "@/preview/ExplorerStyle";
import StyleMountainPreview from "@/preview/MountainStyle";

import GlobalCollapseSetting from "@/desktop/components/GlobalCollapseSetting";
import GlobalProductConfirm from "@/components/GlobalProductConfirm";
import GlobalSectionSetting from "@/desktop/components/GlobalSectionSetting";
import GlobalAddToCart from "@/components/GlobalAddToCart";
import ParseSpecifications from "@/commons/ParseSpecifications";

export default {
	name: "MobileEditor",
	components: {
		StyleClassicPreview,
		StylePoetPreview,
		StyleAstronomerPreview,
		StyleAquarellesPreview,
		StyleRomanticPreview,
		StyleModernPreview,
		StylePhotographerPreview,
		StyleExplorerPreview,
		StyleMountainPreview,

		GlobalCollapseSetting,
		GlobalProductConfirm,
		GlobalSectionSetting,
		GlobalAddToCart,
	},

	props: {
        isNonceReady: {
            type: Boolean
        },
    },

	setup() {
		var appContext = getCurrentInstance();
		const LANG = appContext.appContext.config.globalProperties.LANG;

		var tabOpen = ref('style');
		var classBottomBar = ref('');
		var classScrolLImage = ref('');

		const tabCloseEvent = () => {
			tabOpen.value = "";
		}
		const tabOpenEvent = (tabName) => {
			tabOpen.value = tabName
		}

		const {
			spec,
			selectedOptions,
			posterStyles,
			posterLayout,
			posterSizes,
			additionSettings,
			loadComponentPreview,
			priceFinal,

			selectStyleMethod,
			selectLayoutMethod,
			selectSizeMethod,
			pickSettingMethod,
			addToCartSubmit,

			showPopup,
			cartContext,
			onClosePopupReviewMethod,
			sendEmailMethod,
			StarMapImage,
			previewDimension,
			getPriceIngredient,
		} = AppHelper('mobile');

		window.onscroll = function(ev) {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {

			}

			if (window.scrollY > 150) {
				classBottomBar.value = 'show-bar'
				classScrolLImage.value = 'show-up';
			} else{
				classScrolLImage.value = '';
				classBottomBar.value = '';
			}
		};

		const scrollFromTab = () => {
			window.scrollTo({ top: 440, behavior: 'smooth' });
		}

		const scrollPreset = () => {
			if (window.scrollY < 440) {
				window.scrollTo({ top: 440, behavior: 'smooth' });
			} else {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		}

		window.nse_app.poster_px = previewDimension;

		const styleWrapperPreview = computed(() => {
			return `width:${previewDimension.value.width}px; height:${previewDimension.value.height}px;`;
		});

		const backgroundColors = computed(() => {
			var output = [];

			if (!selectedOptions.value.poster_style.has_background) return output;

			if (selectedOptions.value.star_map_color) {
				output.push(Object.assign({}, selectedOptions.value.star_map_color, {
					"name": "background_color"
				}));
			}

			output.push({
				"title": LANG.COLOR_WHITE,
				"value": "#ffffff",
				"name": "background_color"
			});
			return output;
		});


		const qAUrl = window.nse_config.q_a_url;

		var tabCurrent = ref('style');
		const tabs = computed(() => {
			var output = [{
				"title": LANG.STYLE,
				"name": "style"
			}];

			if (selectedOptions.value.poster_style) {
				selectedOptions.value.poster_style.settings.map((setting) => {
					if (setting.name !== "product_detail") {
						output.push({
							"title": setting.title,
							"name": setting.name
						})
					}
				})
			}

			return output;
		});

		const lastTab = computed(() => {
			return (tabCurrent.value === tabs.value[tabs.value.length - 1].name)
		});

		const iconTab = (tabItem) => {
			const assetUrl = window.nse_config.assets_url;

			const downArrow = assetUrl + 'assets/image/down-arrow.svg';
			const upArrow = assetUrl + 'assets/image/up-arrow.svg';
			const styleIcon = assetUrl + 'assets/image/style-icon.svg';
			const textIcon = assetUrl + 'assets/image/text-icon.svg';
			const momentIcon = assetUrl + 'assets/image/moment-icon.svg';
			const designIcon = assetUrl + 'assets/image/design-icon.svg';
			const productIcon = assetUrl + 'assets/image/product-icon.svg';

			switch (tabItem.name) {
				case "style":
					return styleIcon;
				case "text":
					return textIcon;
				case "moment":
					return momentIcon;
				case "design":
					return designIcon;
				case "product":
					return productIcon;
				case "arrow-down":
					return downArrow;
				case "arrow-up":
					return upArrow;
			}
		}

		const sectionsCurrent = computed(() => {
			return additionSettings.value.find((setting) => {
				return setting.name === tabCurrent.value
			});
		});

		const imageScroll = window.nse_config.assets_url + "assets/image/white-arrow-up-icon.svg";
		const backgroundTrigger = `background-image: url(${window.nse_config.assets_url}assets/image/bg-gradient-mobile.png)`;
		const svgIcon = window.nse_config.assets_url + "img/arrow-add-to-cart.svg";

		const nextStep = () => {
			var stop = false;
			tabs.value.some((tabItem => {

				if (stop) {
					tabCurrent.value = tabItem.name;
					return true;
				}

				if (tabItem.name === tabCurrent.value) {
					stop = true;
				}

				return false;
			}))
		};

		return {
			loadComponentPreview,

			selectedOptions,
			posterStyles,
			posterLayout,
			posterSizes,
			additionSettings,
			priceFinal,
			getPriceIngredient,

			styleWrapperPreview,
			previewDimension,
			//Methods
			selectStyleMethod,
			selectLayoutMethod,
			selectSizeMethod,
			pickSettingMethod,
			addToCartSubmit,

			backgroundColors,

			tabOpen,
			tabCloseEvent,
			tabOpenEvent,


			showPopup,
			cartContext,
			onClosePopupReviewMethod,
			sendEmailMethod,

			qAUrl,
			StarMapImage,


			// Only Mobile
			lastTab,
			tabCurrent,
			tabs,
			iconTab,

			sectionsCurrent,
			imageScroll,
			backgroundTrigger,
			classBottomBar,

			scrollPreset,
			scrollFromTab,
			classScrolLImage,
			svgIcon,
			nextStep
		}
	}
}
